import { Typography } from '@global-engineering-shared/gweb-material-ui';

import useStyles from './SnackbarContent.styles';

export type SnackbarContentProps = {
  header: string;
  message: string;
};

export const defaultSnackbarContentProps: SnackbarContentProps = {
  header: 'Oops, something went wrong...',
  message: 'If the issue persists please report it to our support team',
};

const SnackbarContent = (props: SnackbarContentProps) => {
  const { header, message } = props;
  const classes = useStyles();

  return (
    <>
      <Typography variant="h5" color="white" className={classes.header}>
        {header}
      </Typography>
      <Typography variant="subtitle2" color="white">
        {message}
      </Typography>
    </>
  );
};

export default SnackbarContent;
